// Checkout-page behaviors: order preview modal + ariba XML copy button.

import { getAjaxUrl } from './lib/ajax.js';

function init_order_preview() {
    var btn = document.getElementById('checkout_preview_order');
    if (!btn) return;

    var modal = document.getElementById('zds_preview_modal');
    var body = document.getElementById('zds_preview_body');
    var close = document.getElementById('zds_preview_close');
    var refresh = document.getElementById('zds_preview_refresh');

    function open_modal() { jQuery(modal).show(); }
    function close_modal() { jQuery(modal).hide(); }

    function load_preview() {
        body.textContent = 'Loading…';

        var form_data = new FormData();
        form_data.append('action', 'zds_order_preview');

        jQuery.ajax({
            url: getAjaxUrl(),
            type: 'POST',
            data: form_data,
            processData: false,
            contentType: false,
            xhrFields: { withCredentials: true },

            success: function(json) {
                if (!json || !json.success) {
                    body.textContent = (json && json.data && json.data.message)
                        ? json.data.message
                        : 'Preview failed';
                    return;
                }
                body.innerHTML = json.data.html;
            },

            error: function() {
                body.textContent = 'Preview failed (network error)';
            },
        });
    }

    jQuery(close).on('click', close_modal);

    jQuery(modal).on('click', function(e) {
        if (e.target === modal) close_modal();
    });

    jQuery(btn).on('click', function(e) {
        e.preventDefault();
        open_modal();
        load_preview();
    });

    jQuery(refresh).on('click', function(e) {
        e.preventDefault();
        load_preview();
    });
}

function init_xml_copy_button() {
    function set_btn_state(btn, text) {
        var original = btn.getAttribute('data_original_text');
        if (!original) {
            original = btn.textContent;
            btn.setAttribute('data_original_text', original);
        }

        btn.textContent = text;
        clearTimeout(btn._zds_timer);
        btn._zds_timer = setTimeout(function() {
            btn.textContent = original;
        }, 1500);
    }

    async function copy_text(text) {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }

        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
    }

    document.addEventListener('click', async function(e) {
        var btn = e.target.closest('.zds_copy_xml_btn');
        if (!btn) return;

        var selector = btn.getAttribute('data_copy_target') || '';
        var target = selector ? document.querySelector(selector) : null;

        if (!target) {
            set_btn_state(btn, 'Missing XML');
            return;
        }

        try {
            await copy_text(target.textContent || '');
            set_btn_state(btn, 'Copied ✓');
        } catch (err) {
            set_btn_state(btn, 'Copy failed');
        }
    });
}

export function init() {
    init_order_preview();
    init_xml_copy_button();
}
